import styled, { css } from "styled-components";

export const TableRow = styled.tr`
  display: table-row;
  width: 100%;
  border-radius: 0;
  padding: 0;
  border-radius: 20px;
  position: relative;
  z-index: 0;

  &:nth-child(even) {
    /* background: #fcfcfc; */
  }

   ${({ noNewStyle }) => !noNewStyle && css`
   
   &:first-child {
     &::before{
       inset: -2px -1px -1px -1px;
     }
   }
 
   &::before {
     content: "";
     position: absolute;
     inset: -1px;
     z-index: -1;
     border-radius: inherit;
 
     background: linear-gradient(
       90deg,
       #367eee 0%,
       #b74bff 50.96%,
       #feb508 100%
     );
 
     filter: blur(3px);
     opacity: 0.2;
   }
 
   &::after {
     content: "";
     position: absolute;
     inset: 0;
     z-index: -1;
     border-radius: 15px;
     background: var(--white);
   }
   `}


  ${({ responsive }) =>
    responsive &&
    css`
      @media (max-width: 991px) {
        background: var(--white);
        border: 1px solid var(--table-border);
        display: block;
        padding: 15px;
        border-radius: 10px;
        position: relative;
      }
      @media (max-width: 768px) {
        box-shadow:
          10px 10px 20px rgba(0, 0, 0, 0.05),
          -10px 10px 20px rgba(0, 0, 0, 0.05);
      }
    `}

  @media (min-width: 992px) {
    &:last-child {
      /* border-bottom: 0; */
    }
  }

  @media (min-width: 768px) {
    border-radius: 10px;
  }

  &:hover {
    td {
      @media (min-width: 992px) {
        transition: background var(--animation-speed) ease-in-out;
        background: var(--gray-3);
        cursor: pointer;
      }
    }
  }

  &.dropdown-open {
    z-index: 2000;
  }

  &:focus-within {
    z-index: 1500;
  }
`;

export default TableRow;
